import {
  getMeetingContentHistoryDetails,
  fetchParticipantsSharingBoard,
  startRecording,
  stopRecording,
  getRecordingStatus,
} from '../../redux/meeting/actions';

export const mapStateToProps = state => ({
  meetingContentHistory: state.meeting.meetingContentHistory,
  isLoadingContentHistory: state.meeting.isFetchingMeetingContentHistory,
  token: state.auth.token,
  meetingId: state.meeting.meetingId,
  participantsAccessingCodeShare: state.meeting.participantsAccessingCodeShare,
  hasMeetingStarted: state.meeting.hasMeetingStarted,
  hasMeetingEnded: state.meeting.hasMeetingEnded,
  meetingTitle: state.meeting.title,
  isFetchingParticipantsSharingBoard: state.meeting.isFetchingParticipantsSharingBoard,
  externalMeetingId: state.meeting.connectingVideoId,
  recordingStatus: state.meeting.recordingStatus,
});

export const mapDispatchToProps = dispatch => ({
  getSubmissionsForMeeting: () => {
    dispatch(getMeetingContentHistoryDetails());
  },
  fetchParticipantsSharingBoard: (meetingId) => {
    dispatch(fetchParticipantsSharingBoard(meetingId));
  },
  startRecording: (meetingId) => {
    dispatch(startRecording(meetingId));
  },
  stopRecording: (meetingId) => {
    dispatch(stopRecording(meetingId));
  },
  getRecordingStatus: (meetingId) => {
    dispatch(getRecordingStatus(meetingId));
  },
});
